import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isSidebarOpen: false
}

const slice = createSlice({
  name: 'personalSettings',
  initialState,
  reducers: { }
})

export const { reducer } = slice
